import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import _ from 'lodash';
import { CommonConstant } from 'src/app/constants';
import { TranslocoService } from '@ngneat/transloco';

import { AddItemModifierPromptsModal } from 'src/app/modals';
import { BaseMenuItem } from 'src/app/models';
import { TicketProvider } from 'src/app/providers';
import { ModalService } from 'src/app/services';

@Component({
  selector: 'pos-custom-price-item.modal',
  templateUrl: './custom-price-item.modal.html',
  styleUrls: ['./custom-price-item.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrencyPipe]
})
export class CustomPriceItemModal {
  @Input() menuItem: BaseMenuItem;
  @Input() parentUuid?: string;

  amount: number | string;

  constructor(
    private readonly modalController: ModalController,
    private readonly ticketProvider: TicketProvider,
    private readonly modalService: ModalService,
    private readonly currencyPipe: CurrencyPipe,
    private readonly translocoService: TranslocoService
  ) {}

  onSave() {
    const amount = +this.amount,
      MAX_VARIABLE_VALUE = CommonConstant.MAX_VARIABLE_PRICE_INPUT_VALUE;

    if (amount > MAX_VARIABLE_VALUE) {
      const maxValue = this.currencyPipe.transform(
        MAX_VARIABLE_VALUE,
        'USD',
        'symbol-narrow',
        '1.0-2'
      );
      this.modalService.alert({
        message: this.translocoService.translate(
          'posManager.invalidDollarAmount',
          { maxValue }
        ),
        buttons: [this.translocoService.translate('common.ok')]
      });
      return;
    }

    this.onCloseModal();
    this.menuItem.price = amount;
    if (_.isEmpty(this.menuItem.modifier_prompt_assignments)) {
      this.ticketProvider.ticketItemAddingHandler({
        menuItem: this.menuItem,
        device_ticket_item_uuid: this.parentUuid
      });
    } else {
      this.modalService.showModal(
        AddItemModifierPromptsModal,
        {
          item: this.menuItem
        },
        { cssClass: 'pos-modifier-prompts-modal' },
        (res) => {
          if (res.data) {
            this.ticketProvider.ticketItemAddingWithPrompts(
              res.data.menuItem,
              res.data.options
            );
          }
        }
      );
    }
  }

  onCloseModal() {
    this.modalController.dismiss();
  }
}
